import React from "react"
import classNames from "classnames"
import { Select, Tag } from "antd"
import styles from "./MultipleSelect.module.css"
import PropTypes from "prop-types"

const { Option } = Select

export const MultipleSelect = ({ placeholder, options, disabledOptions = [], ...rest }) => {
  const tagRender = (props) => {
    const { label, value, closable, onClose } = props
    const onPreventMouseDown = (event) => {
      event.preventDefault()
      event.stopPropagation()
    }

    return (
      <Tag
        className={classNames(styles.tag)}
        color={value}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginInlineEnd: 4 }}
      >
        {label}
      </Tag>
    )
  }

  const filterOption = (input, option) => {
    return option.children.toLowerCase().includes(input.toLowerCase())
  }

  return (
    <Select
      popupClassName={styles.dropdown}
      mode="multiple"
      placeholder={placeholder}
      style={{ width: "100%" }}
      tagRender={tagRender}
      filterOption={filterOption}
      {...rest}
    >
      {options?.map((option, index) => (
          <Option
          key={index + 1}
          value={option.id}
          disabled={disabledOptions.includes(option.id)}
        >
          {option.name}
        </Option>
      ))}
    </Select>
  )
}

MultipleSelect.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  disabledOptions: PropTypes.array,
}
